export default "__VITE_ASSET__DzP8WvPf__"